(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 9014:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(5838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var components_site_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51289);
/* harmony import */ var components_site_layoutWrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34109);
/* harmony import */ var components_site_layoutInnerContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22545);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18518);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87379);
/* harmony import */ var _styled_system_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37947);










function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:visited {\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu)(_templateObject(), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
    color: 'gray.900'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
    color: 'blue.700'
}));
var OhhhNoes = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath;
    var category = asPath.split('/')[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_seo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: '404 Page',
                description: 'Oops! Looks like we can’t find the page you’re looking for.'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_layoutWrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bg: "white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_layoutInnerContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: "86vh",
                        m: "0 auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        as: "h1",
                                        fontSize: [
                                            '800',
                                            null,
                                            'clamp(3.5rem, 18vh, 14.27rem)'
                                        ],
                                        lineHeight: [
                                            '800',
                                            null,
                                            'clamp(3.5rem, 20vh, 17.84rem)'
                                        ],
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                        children: "404"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        as: "p",
                                        fontSize: [
                                            '200',
                                            null,
                                            'clamp(1rem, 4vh, 2rem)'
                                        ],
                                        lineHeight: [
                                            '200',
                                            null,
                                            'clamp(1.25rem, 4.2vh, 2.5rem)'
                                        ],
                                        textAlign: "center",
                                        mt: [
                                            '100',
                                            null,
                                            '0'
                                        ],
                                        children: "Oops! Looks like we can’t find the page you’re looking for."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        as: "p",
                                        fontSize: [
                                            '200',
                                            null,
                                            'clamp(1rem, 4vh, 2rem)'
                                        ],
                                        lineHeight: [
                                            '200',
                                            null,
                                            'clamp(1.25rem, 4.2vh, 2.5rem)'
                                        ],
                                        textAlign: "center",
                                        my: [
                                            '400',
                                            null,
                                            '500'
                                        ],
                                        children: [
                                            "Return to",
                                            ' ',
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                href: "/".concat(category),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                                    as: "a",
                                                    href: "/docs",
                                                    children: "Home"
                                                })
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                mt: "500",
                                mb: "700",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "next-image",
                                    alt: "404 image",
                                    src: "/404.png",
                                    width: "1179",
                                    height: "532"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (OhhhNoes);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,675,371,774,888,179], function() { return __webpack_exec__(9014); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);